import { Button, chakra, HTMLChakraProps } from '@chakra-ui/react'
import { ComponentType } from 'react'

interface LoginButtonProps extends HTMLChakraProps<'a'> {
  icon: ComponentType<{ style?: React.CSSProperties }>
  label: string
  href: string
  iconColor?: string
}

export const LoginButton: React.FC<LoginButtonProps> = ({
  icon: Icon,
  label,
  href,
  iconColor,
  ...props
}) => (
  <chakra.a href={href} w="full" {...props}>
    <Button
      size="lg"
      bg="gray.50"
      color="gray.900"
      variant="outline"
      borderColor="gray.200"
      _hover={{ bg: 'gray.100' }}
      borderRadius="full"
      px={8}
      h="12"
      fontWeight="medium"
      w="full"
      gap={3}
      display="flex"
      alignItems="center"
    >
      <Icon style={{ flexShrink: 0, ...(iconColor ? { color: iconColor } : {}) }} />
      <span style={{ lineHeight: 1 }}>{label}</span>
    </Button>
  </chakra.a>
)
